// extracted by mini-css-extract-plugin
export default {"container":"Puzzle_container__k7+yw","countdown":"Puzzle_countdown__r5GFh"};